// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1Qp37","alert":"SettungsInbox_alert__17Xzu"};